import React from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import isUndefined from 'lodash/isUndefined';

// CONTEXT
import { useLogContext } from '../helpers/logContext';

// BOOTSTRAP COMPONENTS
import { Badge } from 'react-bootstrap';

// STYLES
import styles from '../logs.module.scss';

// MAIN COMPONENT
const LogPill = ({
  children,
  className,
  name,
  ...props
}) => {

  // CONTEXT
  const { logs: { [name]: { data } = {} } } = useLogContext() || {};

  // RENDER
  return isUndefined(children) && !name ? null : (
    <Badge
      className={clsx(styles.pill, className)}
      pill
      {...props}
    >{isUndefined(children) ? data?.length || 0 : children}</Badge>
  );
};

// EXPORT
export default LogPill;
